import { render } from "./locustWeb.vue?vue&type=template&id=a7d0f72a"
import script from "./locustWeb.vue?vue&type=script&lang=js"
export * from "./locustWeb.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__